const generateExternalAPIKey = factoringId => async (
  dispatch,
  getState,
  { api }
) => api.factoring.tms.generateExternalAPIKey(factoringId);

export default generateExternalAPIKey;
